import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Overlay } from '@/components/Overlay';
import { TaxedPrice } from '@/components/TaxedPrice';
import { Typography } from '@/components/Typography';

import { ReactComponent as CheckSvg } from '@/assets/icons/check-icon.svg';
import { ReactComponent as CloseSvg } from '@/assets/icons/close-icon.svg';

export const Wrapper = styled.aside`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;

  ${({
    theme: {
      colors: { shadow2, white },
      components: { addToCartDialog },
      media,
    },
  }) => css`
    box-shadow: 0px 3px 6px ${shadow2};
    background-color: ${white};

    ${media.md.up} {
      width: ${addToCartDialog.width};
    }
  `}
`;

export const HeaderWrapper = styled(Flex)`
  position: relative;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 2, 2, 2)};
    border-bottom: 1px solid ${theme.colors.primaryAdd6};
  `}
`;

export const Header = styled(Flex)`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const HeaderText = styled(Typography)`
  padding-top: 4px;
  text-transform: uppercase;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.secondary};
  `}
`;

export const CheckIcon = styled(CheckSvg)`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const CloseButton = styled.button`
  position: absolute !important;
  left: 1rem !important;
  all: unset;
  cursor: pointer;
  transform: translateX(5px);
`;

export const CloseIcon = styled(CloseSvg)`
  width: 24px;
  height: 24px;
  ${({ theme }) => css`
    fill: ${theme.colors.primaryBlue};
  `}
`;

export const Body = styled(Box)`
  overflow: auto;
  min-height: calc(100dvh - 186px);
  max-height: calc(100dvh - 186px);
  ${({ theme }) => css`
    padding: ${theme.spacing(3, 3, 0, 3)};
  `}
`;

export const Footer = styled(Box)`
  justify-content: space-between;

  > a {
    width: 100%;
  }

  ${({ theme }) => css`
    padding: ${theme.spacing(0.25, 3, 3, 3)};
    gap: ${theme.spacing(2)};
  `}
`;

export const TotalWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.primaryAdd6};
    padding: ${theme.spacing(2, 0)};
  `}
`;

export const TotalLabel = styled(Typography)`
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.colors.secondary};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h4};
    font-weight: ${theme.fontWeights.bold};
  `}
`;

export const TotalValue = styled(TaxedPrice)`
  ${({ theme }) => css`
    & > p,
    span {
      color: ${theme.colors.secondary};
      font-family: ${theme.fontFamilies.italianPlate};
      font-size: ${theme.fontSizes.h4};
      font-weight: ${theme.fontWeights.bold};
    }
  `}
`;

export const DrawerOverlay = styled(Overlay)`
  background: red !important;
  padding: 0 !important;
  margin-bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
`;

export const BottomTextWrapper = styled(Box)`
  ${({ theme }) => css`
    background-color: #fff8e0;
    margin: ${theme.spacing(2, 0)};
    padding: ${theme.spacing(1, 1, 1, 4)};
    ul {
      list-style: disc;
    }
  `}
`;
